export default __webpack_public_path__ + "static/media/feature-row.66d120d4.png";